/** «Объявления Авито» — ровно то, что отдаёт `GET /api/avito/items`. Деньги `spend*` — копейки. */
import { apiFetch, query } from "@/lib/api";

export type ItemsGroup = "item" | "city" | "title";

export type ItemsRow = {
  key: string;
  label: string;
  /** Только в разрезе «объявление». */
  item_id?: number;
  city?: string;
  address?: string;
  price?: number | null;
  status?: string;
  url?: string;
  items: number;
  impressions: number;
  views: number;
  contacts: number;
  contacts_messenger: number;
  contacts_phone: number;
  favorites: number;
  spend: number;
  spend_presence: number;
  spend_promo: number;
  /** Обращения «Лидов Авито» и их воронка. */
  chats: number;
  dress: number;
  booked: number;
  bron: number;
  contract: number;
  ctr: number | null;
  conv: number | null;
  /** Рубли за штуку. */
  cost_contact: number | null;
  cost_chat: number | null;
  cost_booked: number | null;
  cost_bron: number | null;
};

export type AvitoItems = {
  from: string;
  to: string;
  group: ItemsGroup;
  groups: Record<ItemsGroup, string>;
  days_total: number;
  days_loaded: number;
  total: ItemsRow;
  rows: ItemsRow[];
  days: {
    day: string;
    impressions: number;
    views: number;
    contacts: number;
    spend: number;
  }[];
  spending: { type: string; service: string; amount: number }[];
};

export function loadAvitoItems(
  from: string,
  to: string,
  group: ItemsGroup,
): Promise<AvitoItems> {
  return apiFetch<AvitoItems>(`/api/avito/items${query({ from, to, group })}`);
}
